import { mixpanel } from '@fiverr-private/obs';
import { getStoredData } from '../utils';
import { MIXPANEL_EVENT_PROPERTIES } from '../../../../../shared/mixpanel';

type ReviewSubmittedPayload = {
    orderId: string;
    rating: number;
    feedback?: string;
};

export const reportReviewSubmitted = ({
    orderId,
    rating,
    feedback,
}: ReviewSubmittedPayload): void => {
    mixpanel.track('Logo Maker - Post Order Page - Review Submitted', {
        [MIXPANEL_EVENT_PROPERTIES.ORDER_ID]: orderId,
        [MIXPANEL_EVENT_PROPERTIES.RATING]: rating,
        [MIXPANEL_EVENT_PROPERTIES.REVIEW]: feedback,
        ...getStoredData(),
    });
};
